import $ from 'jquery';

export default function setHoverEffect($container, $group) {

    const $cards = $($group).find('.card');
    $cards.on('mouseover', function() {
        $container.addClass('-card-hovered');
    }).on('mouseout', function() {
        $container.removeClass('-card-hovered');
    });
}



// WEBPACK FOOTER //
// ./source/scripts/enhancements/hoverEffect.js